import { reports } from '@constants/endpoints';
import { DownloadReport } from '@utils/types';
import { axiosInstance } from './index';

export const downloadReport: DownloadReport = async (
  type,
  start_date,
  end_date,
) => {
  axiosInstance
    .get(reports, {
      params: {
        report_type: `${type}_data`,
        start_date,
        end_date,
      },
      responseType: 'blob',
    })
    .then((response) => {
      const href = URL.createObjectURL(response.data);

      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', `${type}_data.csv`); //or any other extension
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
  return true;
};
